//=============================================================================
// about だいぞう回転アニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", () => {
  // 画像パス（Liquidテンプレートで設定されたShopify asset URLを使用）
  const imagePaths = window.daizoImagePaths || [];

  // 各要素の開始位置
  const startIndices = {
    top: 0, // front
    middle: 2, // back
    bottom: 3, // right
    sp: 0, // front
  };

  const visualElements = document.querySelectorAll("[data-about-visual]");

  // 各要素の現在のインデックスを設定
  const currentIndices = new Map();
  visualElements.forEach((element) => {
    const position = element.getAttribute("data-about-visual");
    currentIndices.set(element, startIndices[position]);

    const img = element.querySelector("img");
    if (img) {
      img.src = imagePaths[startIndices[position]];
    }
  });

  // 画像を切り替える関数
  const changeImage = () => {
    visualElements.forEach((element) => {
      const img = element.querySelector("img");
      if (img) {
        // フェードアウト
        img.setAttribute("data-fade", "true");

        // 次のインデックスを計算
        let currentIndex = currentIndices.get(element);
        const nextIndex = (currentIndex + 1) % imagePaths.length;
        currentIndices.set(element, nextIndex);

        // フェードアウト完了後に画像を切り替えてフェードイン
        setTimeout(() => {
          img.src = imagePaths[nextIndex];
          img.setAttribute("data-fade", "false");
        }, 150);
      }
    });
  };

  setInterval(changeImage, 1200);
});

//=============================================================================
// ファーストビューアニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", () => {
  // 初期状態の設定
  gsap.set('[data-fv-anime="subtext"]', {
    opacity: 0,
    x: -50,
    scale: 0.9,
  });

  gsap.set('[data-fv-anime="title"]', {
    opacity: 0,
    scale: 0.7,
  });

  gsap.set('[data-fv-anime="visual"]', {
    opacity: 0,
    y: 60,
    scale: 0.9,
  });

  gsap.set('[data-fv-anime="subtitle"]', {
    opacity: 0,
    x: 50,
    scale: 0.9,
  });

  // アニメーション関数
  const animateFirstView = () => {
    const tl = gsap.timeline({
      onComplete: () => {
        // ファーストビューアニメーション完了後にフラグを立てる
        window.firstViewAnimationComplete = true;
        // もしイントロアニメーションが待機中なら実行
        if (window.pendingIntroAnimation) {
          window.pendingIntroAnimation();
          window.pendingIntroAnimation = null;
        }
      },
    });

    tl.to('[data-fv-anime="subtext"]', {
      opacity: 1,
      x: 0,
      scale: 1,
      duration: 0.8,
      ease: "power2.inOut",
      keyframes: {
        "60%": { x: 10, scale: 1.02 },
        "100%": { x: 0, scale: 1 },
      },
    })

      .to(
        '[data-fv-anime="title"]',
        {
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: "power2.inOut",
          keyframes: {
            "50%": { scale: 1.1 },
            "100%": { scale: 1 },
          },
        },
        "-=0.6"
      )

      .to(
        '[data-fv-anime="visual"]',
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1.2,
          ease: "power2.inOut",
          keyframes: {
            "60%": { y: -10, scale: 1.02 },
            "100%": { y: 0, scale: 1 },
          },
        },
        "-=0.6"
      )

      .to(
        '[data-fv-anime="subtitle"]',
        {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 0.8,
          ease: "power2.inOut",
          keyframes: {
            "60%": { x: -10, scale: 1.02 },
            "100%": { x: 0, scale: 1 },
          },
        },
        "-=0.6"
      );
  };
  animateFirstView();
});

//=============================================================================
// intro 出現アニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", () => {
  // 初期状態の設定
  gsap.set([".daizo-intro__accessory"], {
    y: 30,
    opacity: 0,
    transformOrigin: "center center",
  });

  gsap.set(
    [
      ".daizo-intro__title",
      ".daizo-intro__text",
      ".daizo-intro__happy",
      ".daizo-intro__sparkle",
      ".daizo-intro__coin",
      ".daizo-intro__apron",
      ".daizo-intro__search",
      ".daizo-intro__working",
    ],
    {
      opacity: 0,
      y: 30,
      scale: 0.8,
      transformOrigin: "center center",
    }
  );

  // PC/SP両方のdropletを初期化
  gsap.set('#pc-intro-bg [id^="droplet-"], #sp-intro-bg [id^="sp-droplet-"]', {
    opacity: 0,
    scale: 0,
    transformOrigin: "center center",
  });
});

// イントロアニメーション実行関数
const executeIntroAnimation = () => {
  console.log("Intro animation triggered");

  // PC/SP別々に要素を取得
  const pcDroplets = document.querySelectorAll('#pc-intro-bg [id^="droplet-"]');
  const spDroplets = document.querySelectorAll(
    '#sp-intro-bg [id^="sp-droplet-"]'
  );

  const tl = gsap.timeline();

  tl.to(".daizo-intro__accessory", {
    opacity: 1,
    y: 0,
    duration: 0.3,
    ease: "power2.out",
  })

    .to(
      ".daizo-intro__title",
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.5,
        ease: "power1.inOut",
      },
      "-=0"
    )

    .to(
      ".daizo-intro__text",
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "power2.out",
      },
      "-=0.2"
    );

  // PC用dropletアニメーション
  if (pcDroplets.length > 0) {
    tl.to(
      pcDroplets,
      {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "back.out(2)",
        stagger: {
          amount: 0.3,
          from: "end",
          ease: "power2.out",
        },
      },
      "<"
    );
  }

  // SP用dropletアニメーション
  if (spDroplets.length > 0) {
    tl.to(
      spDroplets,
      {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "back.out(2)",
        stagger: {
          amount: 0.3,
          from: "end",
          ease: "power2.out",
        },
      },
      "<"
    );
  }

  // intro キャラクターアニメーション
  tl.to(
    [
      ".daizo-intro__happy",
      ".daizo-intro__sparkle",
      ".daizo-intro__coin",
      ".daizo-intro__apron",
      ".daizo-intro__search",
      ".daizo-intro__working",
    ],
    {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.5,
      stagger: 0.1,
    },
    "<"
  );
};

// アニメーション実行
window.addEventListener("load", () => {
  ScrollTrigger.create({
    trigger: ".daizo-intro",
    start: "top 60%",
    end: "bottom 20%",
    toggleActions: "play none none none",
    onEnter: () => {
      // ファーストビューアニメーションが完了している場合は即実行
      if (window.firstViewAnimationComplete) {
        executeIntroAnimation();
      } else {
        // 完了していない場合は待機
        console.log("Waiting for first view animation to complete");
        window.pendingIntroAnimation = executeIntroAnimation;
      }
    },
  });
});
//=============================================================================
// intro キャラクターアニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", function () {
  function createFloatingAnimation(selector, options = {}) {
    const {
      yMovement = -10, // 浮遊の縦移動量
      xMovement = 0, // 浮遊の横移動量
      scale = 1, // 浮遊のスケール
      rotate = 0, // 浮遊の回転量
      duration = 2, // アニメーション時間
      delay = 0, // 開始遅延
      ease = "power2.inOut",
    } = options;

    gsap.to(selector, {
      y: yMovement,
      x: xMovement,
      scale: scale,
      rotate: rotate,
      duration: duration,
      ease: ease,
      yoyo: true,
      repeat: -1,
      delay: delay,
    });
  }

  createFloatingAnimation(".daizo-intro__happy img", {
    yMovement: -18,
    duration: 2.2,
    delay: 0,
  });

  createFloatingAnimation(".daizo-intro__sparkle img", {
    yMovement: -20,
    rotate: -20,
    duration: 3,
    delay: 0.5,
  });

  createFloatingAnimation(".daizo-intro__coin img", {
    yMovement: -18,
    duration: 1.8,
    delay: 0.6,
  });

  createFloatingAnimation(".daizo-intro__apron img", {
    yMovement: -28,
    duration: 2.4,
    delay: 0.9,
  });

  createFloatingAnimation(".daizo-intro__search img", {
    yMovement: -14,
    duration: 1.9,
    delay: 1.2,
  });

  createFloatingAnimation(".daizo-intro__working img", {
    yMovement: -16,
    xMovement: 4,
    ease: "power2.inOut",
    duration: 2.1,
    delay: 1.5,
  });

  createFloatingAnimation(".daizo-fv__visual img", {
    yMovement: -16,
    duration: 2.0,
    delay: 2.0,
  });
});
//=============================================================================
// fv背景スクロールアニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", function () {
  function initBackgroundScroll() {
    const bgWrap = document.querySelector(".daizo-fv__bg-wrap");

    if (bgWrap) {
      // ラップ全体をアニメーション
      gsap.to(bgWrap, {
        xPercent: -50,
        duration: 30,
        ease: "none",
        repeat: -1,
      });
    }
  }
  initBackgroundScroll();
});

gsap.registerPlugin(ScrollTrigger);

//=============================================================================
// about 出現アニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", () => {
  gsap.set([".daizo-about__title img", ".daizo-about__tools img"], {
    y: 30,
    opacity: 0,
    scale: 0.9,
    transformOrigin: "center center",
  });

  gsap.set(
    [
      '[data-about-visual="top"] img',
      '[data-about-visual="middle"] img',
      '[data-about-visual="bottom"] img',
      '[data-about-visual="sp"] img',
    ],
    {
      y: 40,
      opacity: 0,
      scale: 0.8,
      transformOrigin: "center center",
    }
  );

  gsap.set(".daizo-about__info-item", {
    x: 30,
    opacity: 0,
    transformOrigin: "left center",
  });
});

// アニメーション実行
window.addEventListener("load", () => {
  ScrollTrigger.create({
    trigger: ".daizo-about",
    start: "top 70%",
    end: "bottom 20%",
    toggleActions: "play none none none",
    onEnter: () => {
      const tl = gsap.timeline();

      tl.to(".daizo-about__title img", {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.5,
        ease: "power2.out",
      })
        .to(
          ".daizo-about__tools img",
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
          },
          "-=0.2"
        )
        .to(
          '[data-about-visual="sp"] img',
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.2"
        )
        .to(
          '[data-about-visual="top"] img',
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.6,
            ease: "power2.out",
          },
          "<"
        )
        .to(
          '[data-about-visual="middle"] img',
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.4"
        )
        .to(
          '[data-about-visual="bottom"] img',
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.4"
        )
        .to(
          ".daizo-about__info-item",
          {
            opacity: 1,
            x: 0,
            duration: 0.5,
            ease: "power2.out",
            stagger: {
              amount: 0.8,
              from: "start",
              ease: "none",
            },
          },
          "<"
        );
    },
  });
});

//=============================================================================
// link 出現アニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", () => {
  // 初期状態の設定
  gsap.set([".daizo-link-stamp", ".daizo-link-official"], {
    y: 50,
    opacity: 0,
    scale: 0.9,
    transformOrigin: "center center",
  });
  gsap.set(
    [
      ".daizo-link-stamp__title img",
      ".daizo-link-stamp__visual img",
      ".daizo-link-stamp__accent img",
      ".daizo-link-official__title img",
      ".daizo-link-official__visual img",
    ],
    {
      y: 20,
      opacity: 0,
      scale: 0.8,
      transformOrigin: "center center",
    }
  );
});

// アニメーション実行
window.addEventListener("load", () => {
  ScrollTrigger.create({
    trigger: ".daizo-link-stamp",
    start: "top 80%",
    end: "bottom 20%",
    toggleActions: "play none none none",
    onEnter: () => {
      const tl = gsap.timeline();

      tl.to(".daizo-link-stamp", {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "power2.out",
      })

        .to(
          ".daizo-link-stamp__title img",
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)",
          },
          "-=0.5"
        )
        .to(
          ".daizo-link-stamp__visual img",
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.4,
            ease: "power2.out",
          },
          "-=0.4"
        )
        .to(
          ".daizo-link-stamp__accent img",
          {
            opacity: 1,
            y: 0,
            scale: 1,
            rotate: 5,
            duration: 0.5,
            ease: "back.out(2)",
          },
          "-=0.4"
        )
        .to(
          ".daizo-link-stamp__accent img",
          {
            rotate: 0,
            duration: 0.3,
            ease: "power2.out",
          },
          "-=0.1"
        );
    },
  });

  // 公式Xボタン 出現アニメーション
  ScrollTrigger.create({
    trigger: ".daizo-link-official",
    start: "top 80%",
    end: "bottom 20%",
    toggleActions: "play none none none",
    onEnter: () => {
      const tl = gsap.timeline();

      tl.to(".daizo-link-official", {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "power2.out",
      })
        .to(
          ".daizo-link-official__visual img",
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.4,
            ease: "power2.out",
          },
          "-=0.4"
        )
        .to(
          ".daizo-link-official__title img",
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)",
          },
          "-=0.3"
        );
    },
  });
});

//=============================================================================
// link ホバーアニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", function () {
  const stampButton = document.querySelector(".daizo-link-stamp");

  if (stampButton) {
    // ホバーイン時のアニメーション
    stampButton.addEventListener("mouseenter", () => {
      const tl = gsap.timeline();

      tl.to(stampButton, {
        y: -5,
        scale: 1.05,
        duration: 0.5,
        ease: "power2.out",
      })
        .to(
          ".daizo-link-stamp__visual img",
          {
            scale: 1.05,
            duration: 0.5,
            ease: "power2.out",
          },
          "<"
        )
        .to(
          ".daizo-link-stamp__accent img",
          {
            rotate: 5,
            scale: 1.1,
            duration: 0.5,
            ease: "power2.out",
          },
          "-=0.4"
        )
        .to(
          ".daizo-link-stamp__title img",
          {
            scale: 1.05,
            duration: 0.5,
            ease: "power2.out",
          },
          "<"
        );
    });

    // ホバーアウト時のアニメーション
    stampButton.addEventListener("mouseleave", () => {
      gsap.to(
        [
          stampButton,
          ".daizo-link-stamp__visual img",
          ".daizo-link-stamp__accent img",
          ".daizo-link-stamp__title img",
        ],
        {
          y: 0,
          scale: 1,
          rotate: 0,
          duration: 0.5,
          ease: "power2.inOut",
          stagger: 0.05,
        }
      );
    });
  }
});

//=============================================================================
// 公式Xボタン ホバーアニメーション
//=============================================================================
document.addEventListener("DOMContentLoaded", function () {
  const officialButton = document.querySelector(".daizo-link-official");

  if (officialButton) {
    // ホバーイン時のアニメーション
    officialButton.addEventListener("mouseenter", () => {
      const tl = gsap.timeline();

      tl.to(officialButton, {
        y: -5,
        scale: 1.05,
        duration: 0.5,
        ease: "power2.out",
      })
        .to(
          ".daizo-link-official__visual img",
          {
            scale: 1.05,
            duration: 0.5,
            ease: "power2.out",
          },
          "<"
        )
        .to(
          ".daizo-link-official__title img",
          {
            scale: 1.05,
            duration: 0.5,
            ease: "power2.out",
          },
          "<"
        );
    });

    // ホバーアウト時のアニメーション
    officialButton.addEventListener("mouseleave", () => {
      gsap.to(
        [
          officialButton,
          ".daizo-link-official__visual img",
          ".daizo-link-official__title img",
        ],
        {
          y: 0,
          scale: 1,
          duration: 0.5,
          ease: "power2.inOut",
          stagger: 0.05,
        }
      );
    });
  }
});
